<template>
    <div>
        <span v-if="parts.length === 0" class="no-data">
            No {{ partsText }} in model.
        </span>
        <div v-else v-for="(part, i) in parts" :key="i">
            <h3 :id="part.id">
                {{ part.label }}
                &nbsp;&nbsp;&nbsp;
                <el-button class="collapse-btn" @click="collapsePart(part)" icon="el-icon-minus" type="text"/>
                <el-button class="collapse-btn" @click="expandPart(part)" icon="el-icon-plus" type="text"/>
            </h3>
            <el-collapse class="collapse-section" v-model="activePartSections">
                <el-collapse-item :name="collapseName('Assembly', part)">
                    <span slot="title" class="collapse-title">Assembly</span>
                    <report-table-params :table="part.table.assm"/>
                </el-collapse-item>
                <el-collapse-item :name="collapseName('Constraints', part)">
                    <span slot="title" class="collapse-title">Constraints</span>
                    <report-table-params :table="part.table.conn">
                        <div slot="empty" class="empty-notes">
                            <span>No constraints are defined.</span>
                        </div>
                    </report-table-params>
                    <div class="constraint-notes">
                        <small v-if="part.frame">
                            *Unless specified otherwise, part is free to rotate relative to its assembly.
                        </small>
                    </div>
                </el-collapse-item>
                <el-collapse-item :name="collapseName('Geometry', part)">
                    <span slot="title" class="collapse-title">Geometry</span>
                    <report-table-params :table="part.table.geom">
                        <div slot="empty" class="empty-notes">
                            <span>Shafts are rotational reference frames without geometry.</span>
                        </div>
                    </report-table-params>
                </el-collapse-item>
                <!--region PLACEHOLDER {microgeometry} report section ... move to separate report-->
                <!--<el-collapse-item v-if="part.obj.micro" :name="collapseName('Microgeometry', part)">-->
                <!--<span slot="title" class="collapse-title">Microgeometry</span>-->
                <!--<div v-if="part.obj.micro">-->
                <!--&lt;!&ndash;PLACEHOLDER {microgeometry} lead and profile tables&ndash;&gt;-->
                <!--&lt;!&ndash;<report-table-params :table="gearMicroLeadTable" :show-title="false" sub-title="Lead Modifications"/>&ndash;&gt;-->
                <!--&lt;!&ndash;<report-table-params :table="gearMicroProfileTable" :show-title="false" sub-title="Profile Modifications"/>&ndash;&gt;-->
                <!--&lt;!&ndash;PLACEHOLDER {microgeometry} 2D contour plots of each flank&ndash;&gt;-->
                <!--&lt;!&ndash;PLACEHOLDER {microgeometry} 3D relief plots of each flank&ndash;&gt;-->
                <!--</div>-->
                <!--<table v-else class="no-data">-->
                <!--<tr>-->
                <!--<td>No microgeometry modifications.</td>-->
                <!--</tr>-->
                <!--</table>-->
                <!--</el-collapse-item>-->
                <!--endregion-->
                <el-collapse-item :name="collapseName('File', part)">
                    <span slot="title" class="collapse-title">Library</span>
                    <report-table-params :table="part.table.file">
                        <div slot="empty" class="empty-notes">
                            <span>Not maintained in a library.</span>
                        </div>
                    </report-table-params>
                </el-collapse-item>
                <!-- PLACEHOLDER {feature} 2D section view: transverse plane-->
                <!-- PLACEHOLDER {feature} 3D isometric view-->
            </el-collapse>
        </div>
    </div>
</template>

<script>
  import ReportTableParams from "./ReportTableParams";

  export default {
    name: "ReportPart",
    components: {ReportTableParams},
    props: {
      parts: Array,
      typename: String,
      carrier: {
        type: Boolean,
        default: false,
      },
    },

    units: {
      angle: 'deg',
    },
    collapseNames: {
      part: ['Assembly', 'Constraints', 'Geometry', 'File'],
    },

    data() {
      return {
        partsText: 'parts',
        isShaft: false,
        isCarrier: false,
        activePartSections: [],
      }
    },
    mounted() {
      // map parts data to local state for tabular display
      switch (this.typename) {
        case this.$requests.model.TYPENAME.PART.GEAR_DETAIL:
          this.partsText = 'gears';
          break;
        case this.$requests.model.TYPENAME.PART.FRAME:
          if (this.carrier) {
            this.partsText = 'carriers';
            this.isCarrier = true;
          } else {
            this.partsText = 'shafts';
            this.isShaft = true;
          }
          break;
        default:
          throw Error('Part type not recognized.')
      }
    },
    methods: {
      // COLLAPSE NAMES
      collapseName(name, item) {
        return name + item.Id;
      },
      collapsePartNames(part) {
        return this.$options.collapseNames.part.map(name => this.collapseName(name, part));
      },

      // COLLAPSE CLICKS
      collapsePart(part) {
        const removeNames = this.collapsePartNames(part);
        this.activePartSections = this.activePartSections.filter(name => !removeNames.includes(name));
      },
      expandPart(part) {
        this.activePartSections.push(...this.collapsePartNames(part));
      },
    },
  }
</script>

<style scoped>
    /* KEEP CONSISTENT WITH ReportModel */
    span.no-data {
        font-size: var(--font-med);
        font-weight: bold;
    }
    .collapse-btn {
        padding: 0;
    }
    .collapse-section {
        margin-left: 1em;
    }
    .empty-notes {
        display: grid;
        grid-auto-flow: row;
        margin-left: 1em;
        color: var(--color);
    }
    .constraint-notes {
        margin-left: 1em;
        color: var(--color);
        font-style: italic;
    }
</style>
